import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useHousingData } from '../hooks/useHousingData';
import { useSavedProperties } from '../hooks/useSavedProperties';
import HousingCard from '../components/HousingCard';
import SkeletonCard from '../components/SkeletonCard';

const SavedPropertiesPage = () => {
  const { t } = useTranslation();
  const { properties, loading, dataSource } = useHousingData();
  const { savedIds, toggleSaved } = useSavedProperties();

  const savedProperties = properties.filter((p) => savedIds.includes(p.id));

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
            <span>🔖</span>
            <span>{t('saved.title')}</span>
          </h1>
          <p className="text-sm text-gray-500 mt-0.5">
            {t('saved.count', { count: savedProperties.length })}
          </p>
        </div>
        <Link to="/" className="btn-outline text-sm px-4 py-2 whitespace-nowrap">
          {t('saved.browseAll')}
        </Link>
      </div>

      {/* Results */}
      {savedProperties.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {savedProperties.map((housing) => (
            <HousingCard key={housing.id} housing={housing} />
          ))}
        </div>
      ) : loading && properties.length === 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {Array.from({ length: 3 }).map((_, i) => (
            <SkeletonCard key={`skeleton-${i}`} />
          ))}
        </div>
      ) : (
        <div className="text-center py-16" data-testid="saved-empty">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-1">{t('saved.empty')}</h3>
          <p className="text-sm text-gray-500 mb-4">{t('saved.emptyHint')}</p>
          <button
            onClick={() => savedIds.forEach((id) => toggleSaved(id))}
            className="text-sm text-primary-600 hover:text-primary-700 font-medium hover:underline"
          >
            {t('saved.clearAll')}
          </button>
        </div>
      )}
    </div>
  );
};

export default SavedPropertiesPage;